<template>
  <div class="devices-page">
    <div class="devices-section">
      <ulu-devices-sold-charts />
    </div>
    <div class="devices-section">
      <ulu-devices-month-price-stats />
    </div>
    <div class="devices-grid">
      <div class="devices-card">
        <ulu-all-devices-events />
      </div>
      <div class="devices-card">
        <ulu-all-devices-status />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-devices-sold-charts": () =>
      import("@/components/dashboard/devices/DevicesSoldCharts.vue"),
    "ulu-devices-month-price-stats": () =>
      import("@/components/dashboard/devices/DevicesMonthPriceStats.vue"),
    "ulu-all-devices-status": () =>
      import("@/components/dashboard/devices/DevicesStatus.vue"),
    "ulu-all-devices-events": () =>
      import("@/components/dashboard/devices/DevicesEvents.vue")
  }
};
</script>

<style scoped>
.devices-page {
  background-color: #f7f7f7;
  min-height: 100vh;
  padding: 24px;
}

.devices-section {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  overflow: hidden;
}

.devices-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.devices-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

@media (max-width: 768px) {
  .devices-page {
    padding: 16px;
  }
}
</style>
